import React from 'react';
import { Paper } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { DefaultTheme } from '@mui/styles';

interface Props {
	children: any;
	style?: any;
	center?: boolean;
}

export default function AppPaper({ children, center = false, style = {} }: Props) {
	const md = useMediaQuery((theme: DefaultTheme) => theme.breakpoints.up('md'));

	const styles: any = center
		? {
				...style,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
		  }
		: style;

	return (
		<Paper
			sx={{
				padding: md ? 4 : 2,
			}}
			style={styles}
		>
			{children}
		</Paper>
	);
}
